export enum ValidationDocType {
	IdentityCard = 10,
	DrivingLicense = 20,
	Passport = 30,
}

export enum ValidationDocCountryCode {
	Any = 'ANY',
	Israel = 'ISR',
	UnitedStates = 'USA',
}

export type IDocumentVerificationValueSource = OnlyOne<{
	/**
	 * The meta tag key that contains the value to compare with.
	 */
	metaTag: string;
	/**
	 * The static value to compare with.
	 */
	staticValue: string;
}>;
